const e = {
  readItemsPaymentMethodsCollection: {
    schema: {
      method: "get",
      url: "/items/payment_methods_collection",
      security: ["Auth"]
    }
  },
  readSingleItemsPaymentMethodsCollection: {
    schema: {
      method: "get",
      url: "/items/payment_methods_collection/{id}"
    }
  },
  readItemsPromotionCollectionsTranslations: {
    schema: {
      method: "get",
      url: "/items/promotion_collections_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionCollectionsTranslations: {
    schema: {
      method: "get",
      url: "/items/promotion_collections_translations/{id}"
    }
  },
  readItemsGameProvidersCurrencies: {
    schema: {
      method: "get",
      url: "/items/game_providers_currencies",
      security: ["Auth"]
    }
  },
  readSingleItemsGameProvidersCurrencies: {
    schema: {
      method: "get",
      url: "/items/game_providers_currencies/{id}"
    }
  },
  readItemsBannerCollections: {
    schema: {
      method: "get",
      url: "/items/banner_collections",
      security: ["Auth"]
    }
  },
  readSingleItemsBannerCollections: {
    schema: {
      method: "get",
      url: "/items/banner_collections/{id}"
    }
  },
  readItemsShopCategories: {
    schema: {
      method: "get",
      url: "/items/shop_categories",
      security: ["Auth"]
    }
  },
  readSingleItemsShopCategories: {
    schema: {
      method: "get",
      url: "/items/shop_categories/{id}"
    }
  },
  readItemsBannerCollectionsBanners: {
    schema: {
      method: "get",
      url: "/items/banner_collections_banners",
      security: ["Auth"]
    }
  },
  readSingleItemsBannerCollectionsBanners: {
    schema: {
      method: "get",
      url: "/items/banner_collections_banners/{id}"
    }
  },
  readItemsBannerCollectionsFilters: {
    schema: {
      method: "get",
      url: "/items/banner_collections_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsBannerCollectionsFilters: {
    schema: {
      method: "get",
      url: "/items/banner_collections_filters/{id}"
    }
  },
  readItemsBanners: {
    schema: {
      method: "get",
      url: "/items/banners",
      security: ["Auth"]
    }
  },
  readSingleItemsBanners: {
    schema: {
      method: "get",
      url: "/items/banners/{id}"
    }
  },
  readItemsBannersFilters: {
    schema: {
      method: "get",
      url: "/items/banners_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsBannersFilters: {
    schema: {
      method: "get",
      url: "/items/banners_filters/{id}"
    }
  },
  readItemsBannersTranslations: {
    schema: {
      method: "get",
      url: "/items/banners_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsBannersTranslations: {
    schema: {
      method: "get",
      url: "/items/banners_translations/{id}"
    }
  },
  readItemsBannersTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/banners_translations_cta",
      security: ["Auth"]
    }
  },
  readSingleItemsBannersTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/banners_translations_cta/{id}"
    }
  },
  readItemsBonuses: {
    schema: {
      method: "get",
      url: "/items/bonuses",
      security: ["Auth"]
    }
  },
  readSingleItemsBonuses: {
    schema: {
      method: "get",
      url: "/items/bonuses/{id}"
    }
  },
  readItemsBonusesBonusesLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/bonuses_bonuses_localized_keys",
      security: ["Auth"]
    }
  },
  readSingleItemsBonusesBonusesLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/bonuses_bonuses_localized_keys/{id}"
    }
  },
  readItemsBonusesCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/bonuses_currency_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsBonusesCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/bonuses_currency_translations/{id}"
    }
  },
  readItemsBonusesFilters: {
    schema: {
      method: "get",
      url: "/items/bonuses_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsBonusesFilters: {
    schema: {
      method: "get",
      url: "/items/bonuses_filters/{id}"
    }
  },
  readItemsBonusesLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/bonuses_localized_keys",
      security: ["Auth"]
    }
  },
  readSingleItemsBonusesLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/bonuses_localized_keys/{id}"
    }
  },
  readItemsBonusesTranslations: {
    schema: {
      method: "get",
      url: "/items/bonuses_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsBonusesTranslations: {
    schema: {
      method: "get",
      url: "/items/bonuses_translations/{id}"
    }
  },
  readItemsBonusesTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/bonuses_translations_cta",
      security: ["Auth"]
    }
  },
  readSingleItemsBonusesTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/bonuses_translations_cta/{id}"
    }
  },
  readItemsPaymentMethodsItems: {
    schema: {
      method: "get",
      url: "/items/payment_methods_items",
      security: ["Auth"]
    }
  },
  readSingleItemsPaymentMethodsItems: {
    schema: {
      method: "get",
      url: "/items/payment_methods_items/{id}"
    }
  },
  readItemsPaymentMethodsCollectionTranslations: {
    schema: {
      method: "get",
      url: "/items/payment_methods_collection_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsPaymentMethodsCollectionTranslations: {
    schema: {
      method: "get",
      url: "/items/payment_methods_collection_translations/{id}"
    }
  },
  readItemsCountries: {
    schema: {
      method: "get",
      url: "/items/countries",
      security: ["Auth"]
    }
  },
  readSingleItemsCountries: {
    schema: {
      method: "get",
      url: "/items/countries/{id}"
    }
  },
  readItemsCountriesTranslations: {
    schema: {
      method: "get",
      url: "/items/countries_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsCountriesTranslations: {
    schema: {
      method: "get",
      url: "/items/countries_translations/{id}"
    }
  },
  readItemsCta: {
    schema: {
      method: "get",
      url: "/items/cta",
      security: ["Auth"]
    }
  },
  readSingleItemsCta: {
    schema: {
      method: "get",
      url: "/items/cta/{id}"
    }
  },
  readItemsCurrencies: {
    schema: {
      method: "get",
      url: "/items/currencies",
      security: ["Auth"]
    }
  },
  readSingleItemsCurrencies: {
    schema: {
      method: "get",
      url: "/items/currencies/{id}"
    }
  },
  readItemsPaymentMethodsCollectionPaymentMethodsItems: {
    schema: {
      method: "get",
      url: "/items/payment_methods_collection_payment_methods_items",
      security: ["Auth"]
    }
  },
  readSingleItemsPaymentMethodsCollectionPaymentMethodsItems: {
    schema: {
      method: "get",
      url: "/items/payment_methods_collection_payment_methods_items/{id}"
    }
  },
  readItemsShopCategoriesTranslations: {
    schema: {
      method: "get",
      url: "/items/shop_categories_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsShopCategoriesTranslations: {
    schema: {
      method: "get",
      url: "/items/shop_categories_translations/{id}"
    }
  },
  readItemsCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/currency_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/currency_translations/{id}"
    }
  },
  readItemsShopItemShopCategories: {
    schema: {
      method: "get",
      url: "/items/shop_item_shop_categories",
      security: ["Auth"]
    }
  },
  readSingleItemsShopItemShopCategories: {
    schema: {
      method: "get",
      url: "/items/shop_item_shop_categories/{id}"
    }
  },
  createItemsAlerts: {
    schema: {
      method: "post",
      url: "/items/Alerts",
      mediaType: "application/json"
    }
  },
  readItemsAlerts: {
    schema: {
      method: "get",
      url: "/items/Alerts",
      security: ["Auth"]
    }
  },
  readSingleItemsAlerts: {
    schema: {
      method: "get",
      url: "/items/Alerts/{id}"
    }
  },
  readItemsShopItemTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/shop_item_translations_cta",
      security: ["Auth"]
    }
  },
  readSingleItemsShopItemTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/shop_item_translations_cta/{id}"
    }
  },
  createItemsAlertsTranslations: {
    schema: {
      method: "post",
      url: "/items/Alerts_translations",
      mediaType: "application/json"
    }
  },
  readItemsAlertsTranslations: {
    schema: {
      method: "get",
      url: "/items/Alerts_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsAlertsTranslations: {
    schema: {
      method: "get",
      url: "/items/Alerts_translations/{id}"
    }
  },
  readItemsFaqItems: {
    schema: {
      method: "get",
      url: "/items/faq_items",
      security: ["Auth"]
    }
  },
  readSingleItemsFaqItems: {
    schema: {
      method: "get",
      url: "/items/faq_items/{id}"
    }
  },
  readItemsFaqItemsTranslations: {
    schema: {
      method: "get",
      url: "/items/faq_items_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsFaqItemsTranslations: {
    schema: {
      method: "get",
      url: "/items/faq_items_translations/{id}"
    }
  },
  readItemsFaqsCollection: {
    schema: {
      method: "get",
      url: "/items/faqs_collection",
      security: ["Auth"]
    }
  },
  readSingleItemsFaqsCollection: {
    schema: {
      method: "get",
      url: "/items/faqs_collection/{id}"
    }
  },
  readItemsFaqsCollectionFaqItems: {
    schema: {
      method: "get",
      url: "/items/faqs_collection_faq_items",
      security: ["Auth"]
    }
  },
  readSingleItemsFaqsCollectionFaqItems: {
    schema: {
      method: "get",
      url: "/items/faqs_collection_faq_items/{id}"
    }
  },
  readItemsFilters: {
    schema: {
      method: "get",
      url: "/items/filters",
      security: ["Auth"]
    }
  },
  readSingleItemsFilters: {
    schema: {
      method: "get",
      url: "/items/filters/{id}"
    }
  },
  readItemsPaymentMethodsItemsTranslations: {
    schema: {
      method: "get",
      url: "/items/payment_methods_items_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsPaymentMethodsItemsTranslations: {
    schema: {
      method: "get",
      url: "/items/payment_methods_items_translations/{id}"
    }
  },
  readItemsFiltersMarkets: {
    schema: {
      method: "get",
      url: "/items/filters_markets",
      security: ["Auth"]
    }
  },
  readSingleItemsFiltersMarkets: {
    schema: {
      method: "get",
      url: "/items/filters_markets/{id}"
    }
  },
  readItemsGameCategoriesCollections: {
    schema: {
      method: "get",
      url: "/items/game_categories_collections",
      security: ["Auth"]
    }
  },
  readSingleItemsGameCategoriesCollections: {
    schema: {
      method: "get",
      url: "/items/game_categories_collections/{id}"
    }
  },
  readItemsGameCategoriesCollectionsFilters: {
    schema: {
      method: "get",
      url: "/items/game_categories_collections_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsGameCategoriesCollectionsFilters: {
    schema: {
      method: "get",
      url: "/items/game_categories_collections_filters/{id}"
    }
  },
  readItemsGameCategoriesCollectionsGames: {
    schema: {
      method: "get",
      url: "/items/game_categories_collections_games",
      security: ["Auth"]
    }
  },
  readSingleItemsGameCategoriesCollectionsGames: {
    schema: {
      method: "get",
      url: "/items/game_categories_collections_games/{id}"
    }
  },
  readItemsGameCategoriesCollectionsTranslations: {
    schema: {
      method: "get",
      url: "/items/game_categories_collections_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsGameCategoriesCollectionsTranslations: {
    schema: {
      method: "get",
      url: "/items/game_categories_collections_translations/{id}"
    }
  },
  readItemsGameLobbies: {
    schema: {
      method: "get",
      url: "/items/game_lobbies",
      security: ["Auth"]
    }
  },
  readSingleItemsGameLobbies: {
    schema: {
      method: "get",
      url: "/items/game_lobbies/{id}"
    }
  },
  readItemsGameProviders: {
    schema: {
      method: "get",
      url: "/items/game_providers",
      security: ["Auth"]
    }
  },
  readSingleItemsGameProviders: {
    schema: {
      method: "get",
      url: "/items/game_providers/{id}"
    }
  },
  readItemsGameLobbiesFilters: {
    schema: {
      method: "get",
      url: "/items/game_lobbies_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsGameLobbiesFilters: {
    schema: {
      method: "get",
      url: "/items/game_lobbies_filters/{id}"
    }
  },
  readItemsGameLobbiesGameCategoriesCollections: {
    schema: {
      method: "get",
      url: "/items/game_lobbies_game_categories_collections",
      security: ["Auth"]
    }
  },
  readSingleItemsGameLobbiesGameCategoriesCollections: {
    schema: {
      method: "get",
      url: "/items/game_lobbies_game_categories_collections/{id}"
    }
  },
  readItemsGameLobbiesTranslations: {
    schema: {
      method: "get",
      url: "/items/game_lobbies_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsGameLobbiesTranslations: {
    schema: {
      method: "get",
      url: "/items/game_lobbies_translations/{id}"
    }
  },
  readItemsGameTags: {
    schema: {
      method: "get",
      url: "/items/game_tags",
      security: ["Auth"]
    }
  },
  readSingleItemsGameTags: {
    schema: {
      method: "get",
      url: "/items/game_tags/{id}"
    }
  },
  readItemsGameTagsTranslations: {
    schema: {
      method: "get",
      url: "/items/game_tags_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsGameTagsTranslations: {
    schema: {
      method: "get",
      url: "/items/game_tags_translations/{id}"
    }
  },
  readItemsGameThumbnail: {
    schema: {
      method: "get",
      url: "/items/game_thumbnail",
      security: ["Auth"]
    }
  },
  readSingleItemsGameThumbnail: {
    schema: {
      method: "get",
      url: "/items/game_thumbnail/{id}"
    }
  },
  readItemsGameTypes: {
    schema: {
      method: "get",
      url: "/items/game_types",
      security: ["Auth"]
    }
  },
  readSingleItemsGameTypes: {
    schema: {
      method: "get",
      url: "/items/game_types/{id}"
    }
  },
  readItemsGameTypesTranslations: {
    schema: {
      method: "get",
      url: "/items/game_types_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsGameTypesTranslations: {
    schema: {
      method: "get",
      url: "/items/game_types_translations/{id}"
    }
  },
  readItemsGames: {
    schema: {
      method: "get",
      url: "/items/games",
      security: ["Auth"]
    }
  },
  readSingleItemsGames: {
    schema: {
      method: "get",
      url: "/items/games/{id}"
    }
  },
  readItemsGamesFilters: {
    schema: {
      method: "get",
      url: "/items/games_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsGamesFilters: {
    schema: {
      method: "get",
      url: "/items/games_filters/{id}"
    }
  },
  readItemsGamesGameTags: {
    schema: {
      method: "get",
      url: "/items/games_game_tags",
      security: ["Auth"]
    }
  },
  readSingleItemsGamesGameTags: {
    schema: {
      method: "get",
      url: "/items/games_game_tags/{id}"
    }
  },
  readItemsGamesTranslations: {
    schema: {
      method: "get",
      url: "/items/games_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsGamesTranslations: {
    schema: {
      method: "get",
      url: "/items/games_translations/{id}"
    }
  },
  readItemsJackpots: {
    schema: {
      method: "get",
      url: "/items/jackpots",
      security: ["Auth"]
    }
  },
  readSingleItemsJackpots: {
    schema: {
      method: "get",
      url: "/items/jackpots/{id}"
    }
  },
  readItemsLanguages: {
    schema: {
      method: "get",
      url: "/items/languages",
      security: ["Auth"]
    }
  },
  readSingleItemsLanguages: {
    schema: {
      method: "get",
      url: "/items/languages/{id}"
    }
  },
  readItemsLanguagesFilters: {
    schema: {
      method: "get",
      url: "/items/languages_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsLanguagesFilters: {
    schema: {
      method: "get",
      url: "/items/languages_filters/{id}"
    }
  },
  readItemsMarkets: {
    schema: {
      method: "get",
      url: "/items/markets",
      security: ["Auth"]
    }
  },
  readSingleItemsMarkets: {
    schema: {
      method: "get",
      url: "/items/markets/{id}"
    }
  },
  readItemsMenuItems: {
    schema: {
      method: "get",
      url: "/items/menu_items",
      security: ["Auth"]
    }
  },
  readSingleItemsMenuItems: {
    schema: {
      method: "get",
      url: "/items/menu_items/{id}"
    }
  },
  readItemsMenuItemsCollections: {
    schema: {
      method: "get",
      url: "/items/menu_items_collections",
      security: ["Auth"]
    }
  },
  readSingleItemsMenuItemsCollections: {
    schema: {
      method: "get",
      url: "/items/menu_items_collections/{id}"
    }
  },
  readItemsMenuItemsCollectionsFilters: {
    schema: {
      method: "get",
      url: "/items/menu_items_collections_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsMenuItemsCollectionsFilters: {
    schema: {
      method: "get",
      url: "/items/menu_items_collections_filters/{id}"
    }
  },
  readItemsMenuItemsCollectionsMenuItems: {
    schema: {
      method: "get",
      url: "/items/menu_items_collections_menu_items",
      security: ["Auth"]
    }
  },
  readSingleItemsMenuItemsCollectionsMenuItems: {
    schema: {
      method: "get",
      url: "/items/menu_items_collections_menu_items/{id}"
    }
  },
  readItemsMenuItemsCollectionsTranslations: {
    schema: {
      method: "get",
      url: "/items/menu_items_collections_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsMenuItemsCollectionsTranslations: {
    schema: {
      method: "get",
      url: "/items/menu_items_collections_translations/{id}"
    }
  },
  readItemsMenuItemsFilters: {
    schema: {
      method: "get",
      url: "/items/menu_items_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsMenuItemsFilters: {
    schema: {
      method: "get",
      url: "/items/menu_items_filters/{id}"
    }
  },
  readItemsMenuItemsMenuItemsCollections: {
    schema: {
      method: "get",
      url: "/items/menu_items_menu_items_collections",
      security: ["Auth"]
    }
  },
  readSingleItemsMenuItemsMenuItemsCollections: {
    schema: {
      method: "get",
      url: "/items/menu_items_menu_items_collections/{id}"
    }
  },
  readItemsMenuItemsTranslations: {
    schema: {
      method: "get",
      url: "/items/menu_items_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsMenuItemsTranslations: {
    schema: {
      method: "get",
      url: "/items/menu_items_translations/{id}"
    }
  },
  readItemsMetadata: {
    schema: {
      method: "get",
      url: "/items/metadata",
      security: ["Auth"]
    }
  },
  readSingleItemsMetadata: {
    schema: {
      method: "get",
      url: "/items/metadata/{id}"
    }
  },
  readItemsPaymentMethods: {
    schema: {
      method: "get",
      url: "/items/payment_methods",
      security: ["Auth"]
    }
  },
  readSingleItemsPaymentMethods: {
    schema: {
      method: "get",
      url: "/items/payment_methods/{id}"
    }
  },
  readItemsPaymentMethodsFilters: {
    schema: {
      method: "get",
      url: "/items/payment_methods_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsPaymentMethodsFilters: {
    schema: {
      method: "get",
      url: "/items/payment_methods_filters/{id}"
    }
  },
  readItemsPaymentMethodsTranslations: {
    schema: {
      method: "get",
      url: "/items/payment_methods_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsPaymentMethodsTranslations: {
    schema: {
      method: "get",
      url: "/items/payment_methods_translations/{id}"
    }
  },
  readItemsPromotionCollections: {
    schema: {
      method: "get",
      url: "/items/promotion_collections",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionCollections: {
    schema: {
      method: "get",
      url: "/items/promotion_collections/{id}"
    }
  },
  readItemsPromotionCollectionsFilters: {
    schema: {
      method: "get",
      url: "/items/promotion_collections_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionCollectionsFilters: {
    schema: {
      method: "get",
      url: "/items/promotion_collections_filters/{id}"
    }
  },
  readItemsPromotionCollectionsPromotions: {
    schema: {
      method: "get",
      url: "/items/promotion_collections_promotions",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionCollectionsPromotions: {
    schema: {
      method: "get",
      url: "/items/promotion_collections_promotions/{id}"
    }
  },
  readItemsPromotions: {
    schema: {
      method: "get",
      url: "/items/promotions",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotions: {
    schema: {
      method: "get",
      url: "/items/promotions/{id}"
    }
  },
  readItemsPromotionsCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/promotions_currency_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionsCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/promotions_currency_translations/{id}"
    }
  },
  readItemsPromotionsFilters: {
    schema: {
      method: "get",
      url: "/items/promotions_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionsFilters: {
    schema: {
      method: "get",
      url: "/items/promotions_filters/{id}"
    }
  },
  readItemsPromotionsLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/promotions_localized_keys",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionsLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/promotions_localized_keys/{id}"
    }
  },
  readItemsPromotionsPromotionsLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/promotions_promotions_localized_keys",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionsPromotionsLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/promotions_promotions_localized_keys/{id}"
    }
  },
  readItemsPromotionsTranslations: {
    schema: {
      method: "get",
      url: "/items/promotions_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionsTranslations: {
    schema: {
      method: "get",
      url: "/items/promotions_translations/{id}"
    }
  },
  readItemsPromotionsTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/promotions_translations_cta",
      security: ["Auth"]
    }
  },
  readSingleItemsPromotionsTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/promotions_translations_cta/{id}"
    }
  },
  readItemsRegistrationBonuses: {
    schema: {
      method: "get",
      url: "/items/registration_bonuses",
      security: ["Auth"]
    }
  },
  readSingleItemsRegistrationBonuses: {
    schema: {
      method: "get",
      url: "/items/registration_bonuses/{id}"
    }
  },
  readItemsRegistrationBonusesTranslations: {
    schema: {
      method: "get",
      url: "/items/registration_bonuses_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsRegistrationBonusesTranslations: {
    schema: {
      method: "get",
      url: "/items/registration_bonuses_translations/{id}"
    }
  },
  readItemsRewards: {
    schema: {
      method: "get",
      url: "/items/rewards",
      security: ["Auth"]
    }
  },
  readSingleItemsRewards: {
    schema: {
      method: "get",
      url: "/items/rewards/{id}"
    }
  },
  readItemsRewardsCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/rewards_currency_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsRewardsCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/rewards_currency_translations/{id}"
    }
  },
  readItemsRewardsLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/rewards_localized_keys",
      security: ["Auth"]
    }
  },
  readSingleItemsRewardsLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/rewards_localized_keys/{id}"
    }
  },
  readItemsShopItem: {
    schema: {
      method: "get",
      url: "/items/shop_item",
      security: ["Auth"]
    }
  },
  readSingleItemsShopItem: {
    schema: {
      method: "get",
      url: "/items/shop_item/{id}"
    }
  },
  readItemsRewardsRewardsLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/rewards_rewards_localized_keys",
      security: ["Auth"]
    }
  },
  readSingleItemsRewardsRewardsLocalizedKeys: {
    schema: {
      method: "get",
      url: "/items/rewards_rewards_localized_keys/{id}"
    }
  },
  readItemsRewardsTranslations: {
    schema: {
      method: "get",
      url: "/items/rewards_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsRewardsTranslations: {
    schema: {
      method: "get",
      url: "/items/rewards_translations/{id}"
    }
  },
  readItemsRewardsTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/rewards_translations_cta",
      security: ["Auth"]
    }
  },
  readSingleItemsRewardsTranslationsCta: {
    schema: {
      method: "get",
      url: "/items/rewards_translations_cta/{id}"
    }
  },
  readItemsShop: {
    schema: {
      method: "get",
      url: "/items/shop",
      security: ["Auth"]
    }
  },
  readSingleItemsShop: {
    schema: {
      method: "get",
      url: "/items/shop/{id}"
    }
  },
  readItemsShopFilters: {
    schema: {
      method: "get",
      url: "/items/shop_filters",
      security: ["Auth"]
    }
  },
  readSingleItemsShopFilters: {
    schema: {
      method: "get",
      url: "/items/shop_filters/{id}"
    }
  },
  readItemsShopItemTranslations: {
    schema: {
      method: "get",
      url: "/items/shop_item_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsShopItemTranslations: {
    schema: {
      method: "get",
      url: "/items/shop_item_translations/{id}"
    }
  },
  readItemsShopItemCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/shop_item_currency_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsShopItemCurrencyTranslations: {
    schema: {
      method: "get",
      url: "/items/shop_item_currency_translations/{id}"
    }
  },
  readItemsShopShopItem: {
    schema: {
      method: "get",
      url: "/items/shop_shop_item",
      security: ["Auth"]
    }
  },
  readSingleItemsShopShopItem: {
    schema: {
      method: "get",
      url: "/items/shop_shop_item/{id}"
    }
  },
  readItemsTenantConfig: {
    schema: {
      method: "get",
      url: "/items/tenant_config",
      security: ["Auth"]
    }
  },
  readSingleItemsTenantConfig: {
    schema: {
      method: "get",
      url: "/items/tenant_config/{id}"
    }
  },
  readItemsTranslationRichText: {
    schema: {
      method: "get",
      url: "/items/translation_rich_text",
      security: ["Auth"]
    }
  },
  readSingleItemsTranslationRichText: {
    schema: {
      method: "get",
      url: "/items/translation_rich_text/{id}"
    }
  },
  readItemsTranslationRichTextTranslations: {
    schema: {
      method: "get",
      url: "/items/translation_rich_text_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsTranslationRichTextTranslations: {
    schema: {
      method: "get",
      url: "/items/translation_rich_text_translations/{id}"
    }
  },
  readItemsTranslations: {
    schema: {
      method: "get",
      url: "/items/translations",
      security: ["Auth"]
    }
  },
  readSingleItemsTranslations: {
    schema: {
      method: "get",
      url: "/items/translations/{id}"
    }
  },
  readItemsTranslationsTranslations: {
    schema: {
      method: "get",
      url: "/items/translations_translations",
      security: ["Auth"]
    }
  },
  readSingleItemsTranslationsTranslations: {
    schema: {
      method: "get",
      url: "/items/translations_translations/{id}"
    }
  }
};
export {
  e as itemsService
};
